import TextField from '@mui/material/TextField'
import { useI18N } from '@tm/client-form/src/hooks/useI18n'
import { CommentField, TextAreaField } from '@tm/shared-lib/src/field'
import { InputProps, stringValue } from './types'

export function TextAreaInput(props: InputProps<TextAreaField | CommentField>) {
  const { tt } = useI18N()
  const { field, value, onChange, isSubmitting } = props
  const label = tt(field.label)
  const placeholder = 'placeholder' in field ? tt(field.placeholder) : ''

  return (
    <TextField
      value={stringValue(value)}
      onChange={event => onChange(event.target.value)}
      disabled={isSubmitting}
      multiline
      rows={'rows' in field ? field.rows || 4 : 4}
      fullWidth
      variant="filled"
      key={`f-${field.name}`}
      id={`f-${field.name}`}
      hiddenLabel
      placeholder={placeholder || label}
    />
  )
}
